export const FREE_CANVAS_ICON_BASE_URL = 'https://photostudio-ai-oss.arcsoft.com.cn//photostudio-opshub/FreeCanvas';
export const IMAGE_NODE_WIDTH = 240; // 图片节点默认宽度
export const IMAGE_NODE_HEIGHT = 320; // 图片节点默认高度
// 图片节点标题前缀
export const IMAGE_NODE_PREFIX = '图';
export const MIN_ZOOM_PERCENT = 10; // 画布最小缩放百分比
export const MAX_ZOOM_PERCENT = 200; // 画布最大缩放百分比
export const WHEEL_ZOOM_STEP = 20; // 滚轮缩放步进
export const CTRL_WHEEL_ZOOM_SENSITIVITY = 0.001; // Ctrl + 滚轮缩放灵敏度
export const CTRL_WHEEL_MAX_DELTA_PER_FRAME = 80; // 限制单帧缩放幅度，避免部分鼠标一次跳动过大
export const UPLOAD_IMAGE_ACCEPT = 'image/*'; // 图片上传类型限制
export const IMAGE_NODE_GAP = 24; // 批量插入图片节点时的间距
export const PENDING_CONNECTION_NODE_ID = '__free-canvas-pending-connection-node__';
export const PENDING_CONNECTION_EDGE_ID = '__free-canvas-pending-connection-edge__';
export const HISTORY_LIMIT = 50; // 撤销历史最大保留数量
export const PASTE_OFFSET_STEP = 32; // 连续粘贴时的位移步进
export const CONNECTED_NODE_OFFSET_X = 320; // 快速追加节点时的横向偏移
export const CONNECTED_NODE_OFFSET_Y = 0; // 快速追加节点时的纵向偏移
export const MANUAL_ADD_OFFSET_STEP = 36; // 手动新增节点的错位步进
export const MANUAL_ADD_OFFSET_WRAP = 6; // 手动新增节点换行前的数量
export const DUPLICATE_OFFSET_STEP = 40; // 复制节点时的位移步进
export const GROUP_PADDING_X = 24; // 分组左右内边距
export const GROUP_PADDING_BOTTOM = 24; // 分组底部内边距
export const GROUP_HEADER_HEIGHT = 56; // 分组头部高度
export const GROUP_MIN_WIDTH = 320; // 分组最小宽度
export const GROUP_MIN_HEIGHT = 220; // 分组最小高度
export const DEFAULT_VIEWPORT = { x: 0, y: 0, zoom: 1 }; // 画布默认视口
export const PROJECT_PAGE_SIZE = 20; // 项目列表分页大小
export const LAST_ACTIVE_PROJECT_STORAGE_KEY = 'free_canvas_last_active_project_id';
export const LAST_ACTIVE_ORG_KEY_STORAGE_KEY = 'free_canvas_last_active_org_key';
export const RUN_GROUP_SKIP_SELECT_STORAGE_KEY = 'free_canvas_run_group_skip_select_v2';
export const TEMPLATE_PREVIEW_PADDING = 24;
export const TEMPLATE_PREVIEW_EXPORT_SCALE = 2;
export const TEMPLATE_EXPORT_BACKGROUND = '#F3F3F5';
export const TEMPLATE_RENDER_PLACEHOLDER_IMAGE_URLS = new Set([
    'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-opshub/FreeCanvas/node-image.svg',
    'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-opshub/FreeCanvas/node-image.svg',
]);

export const FUNCTION_NODE_INPUT_LIMITS = {
    templateReplace: 14,
    templateReplaceExpt: 3,
    materialHD: 2,
    skinHD: 1,
    faceSwap: 2,
    imageUpscale: 1,
    creativeImg2Img: 14,
    creativeTxt2Img: 0,
    shoesTryon: 4,
    shoesRefiner: 5,
    repose: 2,
    relight: 3,
    creativeColor: 2,
};
export const MULTI_IMAGE_FUNCTION_KEYS = new Set(['creativeImg2Img', 'templateReplace']);
// 前端节点类型到后端节点类型的映射
export const NODE_TYPE_MAP = {
    imageNode: 'resource',
    functionNode: 'function',
    groupNode: 'group',
};
// 资源节点对应的资源类型映射
export const RESOURCE_TYPE_MAP = {
    imageNode: 'image',
};
// 默认输入槽位与参数字段的映射
export const DEFAULT_SLOT_PARAM_KEY_MAP = {
    source: 'srcImage',
    commodity: 'commodityImage',
    match: 'matchImage',
    reference: 'refImage',
    otherView1: 'otherView1Image',
    otherView2: 'otherView2Image',
};
// 特定功能节点的输入槽位字段覆盖配置
export const FUNCTION_SLOT_PARAM_KEY_MAP = {
    materialHD: {
        reference: 'refImage',
        source: 'srcImage',
    },
    shoesTryon: {
        source: 'srcImage',
        reference: 'refImage',
        otherView1: 'angle1',
        otherView2: 'angle2',
    },
    shoesRefiner: {
        source: 'srcImage',
        commodity: 'commodityImage',
        otherView1: 'angle1',
        otherView2: 'angle2',
    },
    relight: {
        source: 'refImage',
        reference: 'srcImage',
        match: 'matchImage',
    },
    creativeColor: {
        source: 'srcImage',
        reference: 'refImage',
    },
    creativeImg2Img: {
        source: 'imageUrls',
    },
};
export const FUNCTION_SLOT_REPAINT_MASK_PARAM_KEY_MAP = {
    creativeColor: {
        source: 'srcImageRepaintBinaryMask',
        reference: 'refImageRepaintBinaryMask',
    },
};
// 各功能节点必填输入槽位配置
export const FUNCTION_REQUIRED_INPUTS_MAP = {
    templateReplace: [
        { key: 'source', label: '模特图' },
        { key: 'reference', label: '参考图' },
    ],
    templateReplaceExpt: [
        { key: 'source', label: '源素材' },
        { key: 'reference', label: '参考图' },
    ],
    materialHD: [
        { key: 'source', label: '面料平铺图' },
        { key: 'reference', label: '模特/服装图' },
    ],
    skinHD: [
        { key: 'source', label: '源素材' },
    ],
    imageUpscale: [
        { key: 'source', label: '输入图' },
    ],
    faceSwap: [
        { key: 'source', label: '源素材' },
        { key: 'reference', label: '参考图' },
    ],
    shoesTryon: [
        { key: 'source', label: '源素材' },
        { key: 'reference', label: '参考图' },
    ],
    shoesRefiner: [
        { key: 'source', label: '源素材' },
        { key: 'commodity', label: '商品图' },
        { key: 'reference', label: '参考图' },
    ],
    repose: [
        { key: 'source', label: '源素材' },
    ],
    relight: [
        { key: 'source', label: '源素材' },
    ],
    creativeColor: [
        { key: 'source', label: '模特图' },
        { key: 'reference', label: '参考模特图' },
    ],
};
// 前端功能标识与后端功能编码的映射
export const FUNCTION_CODE_MAP = {
    templateReplace: 'edit_part_psai',
    templateReplaceExpt: 'sim_try_on_expt',
    materialHD: 'fabric_transfer_psai',
    skinHD: 'image_h_pro',
    faceSwap: 'change_model',
    imageUpscale: 'image_finer_psai',
    creativeImg2Img: 'creative_image_to_image_psai',
    creativeTxt2Img: 'creative_text_to_image',
    shoesTryon: 'shoes_tryon',
    shoesRefiner: 'shoes_refiner',
    repose: 'pose_fantasy',
    relight: 'change_color_psai',
    creativeColor: 'recolor_block_psai',
};
// 后端功能编码反查前端功能标识
export const FUNCTION_KEY_BY_CODE_MAP = Object.fromEntries(
    Object.entries({
        ...FUNCTION_CODE_MAP,
        creative_txt2img: 'creativeTxt2Img',
        image_finer: 'imageUpscale',
        relight: 'relight',
        sim_try_on: 'templateReplace',
        creative_image_to_image: 'creativeImg2Img',
        try_on_spro_fabric: 'materialHD',
    }).map(([functionCode, functionKey]) => [functionCode, functionKey]),
);
// 后端节点类型到前端节点类型的映射
export const SERVER_NODE_TYPE_MAP = {
    resource: 'imageNode',
    function: 'functionNode',
    group: 'groupNode',
};
export const EXECUTION_STATUS_TERMINAL = new Set(['success', 'succeeded', 'completed', 'failed', 'stopped', 'canceled', 'cancelled']); // 执行结束态集合
export const EXECUTION_STATUS_SUCCEEDED = new Set(['success', 'succeeded', 'completed']);
export const EXECUTION_POLL_INTERVAL_MS = 5000;
export const EXECUTION_POLL_MAX_RETRY_INTERVAL_MS = 30000;
export const SKIP_AUTO_SELECT_QUERY_KEY = 'skip_auto_select'; // 跳过默认选中项目的查询参数
export const CREATE_PROJECT_QUERY_KEY = 'create_project'; // 进入页面后自动创建新项目
export const TARGET_PROJECT_ID_QUERY_KEY = 'project_id'; // 目标项目 ID 的查询参数
export const TARGET_PROJECT_NAME_QUERY_KEY = 'project_name'; // 目标项目名称的查询参数
export const TARGET_EXECUTION_ID_QUERY_KEY = 'execution_id'; // 目标执行记录 ID 的查询参数
export const TARGET_PROJECT_MEMBER_USER_ID_QUERY_KEY = 'project_member_user_id'; // 企业成员项目所属用户 ID
export const PM_VIEW_QUERY_KEY = 'pm_view'; // PM 只读查看模式的查询参数
export const FORCE_PERSONAL_MEMBER_QUERY_KEY = 'force_personal_member'; // 强制使用个人项目列表
export const SOURCE_PAGE_QUERY_KEY = 'source_page'; // 进入画布的来源页面
export const SOURCE_TAB_QUERY_KEY = 'source_tab'; // 来源页面 tab
export const RETURN_TO_QUERY_KEY = 'return_to'; // 退出画布时优先返回的目标地址
export const FREE_CANVAS_CREATIVE_BOOTSTRAP_STORAGE_KEY = 'free_canvas_creative_node_bootstrap';
export const FREE_CANVAS_CREATIVE_BOOTSTRAP_MAX_AGE = 5 * 60 * 1000;
export const DEFAULT_CANVAS_PROJECT_NAME = '未命名画布';
export const CREATIVE_IMG_ALLOWED_RATIOS = new Set(['1:1', '2:3', '3:2', '3:4', '4:3', '9:16', '16:9', '21:9']);
export const CREATIVE_IMG_ALLOWED_COUNTS = new Set([1, 2, 4, 8]);

export const MIME_EXTENSION_MAP = {
    'image/jpeg': 'jpg',
    'image/jpg': 'jpg',
    'image/png': 'png',
    'image/webp': 'webp',
    'image/gif': 'gif',
    'image/bmp': 'bmp',
    'image/svg+xml': 'svg',
};
export const FLOW_LINK_PLACEHOLDER_ICON = 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-opshub/FreeCanvas/node-image.svg';

export const TEMPLATE_IMAGE_INPUT_PARAM_KEYS = new Set([
    'imageUrls',
    'srcImage',
    'refImage',
    'commodityImage',
    'matchImage',
    'angle1',
    'angle2',
    'otherView1Image',
    'otherView2Image',
    'output',
]);

export const CANVAS_VERSION_CONFLICT_CODE = -5004;
export const CANVAS_VERSION_CONFLICT_MESSAGE = '画布版本已变更,请刷新后重试';

export const GROUP_ACTIVE_STATUS_PRIORITY = {
    processing: 3,
    manual: 2,
    queued: 1,
    pending: 1,
};